import { createContext, useContext, type ReactNode } from 'react';
import type { FinanceApi } from './finance.js';

const Context = createContext<FinanceApi | null>(null);

export function FinanceApiProvider({ api, children }: { api: FinanceApi; children: ReactNode }) {
  return <Context.Provider value={api}>{children}</Context.Provider>;
}

export function useFinanceApi(): FinanceApi {
  const api = useContext(Context);
  if (api === null) throw new Error('useFinanceApi вызван вне FinanceApiProvider');
  return api;
}
